module.exports = __webpack_public_path__ + "static/media/truck-marker.2424bae7.svg";